import { CompanysitesService } from '../../../admin-dashboard/company-sites/company-sites.service';
import { Component, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CompanyReportGeneratorService } from '../../../services/company-report-generator.service';
import { ActivatedRoute } from '@angular/router';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';

import { map, Observable, Subject, Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { SystemService } from '../../../services/system.service';
import { ProductService } from 'src/app/admin-dashboard/product/product.service';
@Component({
  selector: 'app-company-report-generator-result',
  templateUrl: './company-report-generator-result.component.html',
  styleUrls: ['./company-report-generator-result.component.css']
})
export class CompanyReportGeneratorResultComponent implements OnDestroy {
  @ViewChild('table', { static: false }) table: ElementRef;
  dataSource$: Observable<MatTableDataSource<any>>;
  filter$: Subject<string>;
  dataSource;
  columnSettings$: Observable<ColumnSetting[]>;

  siteName: string;
  systemName: string;
  employee: string;
  product: string;
  dateFrom: string;
  dateTo: string;
  forceLoading: boolean = true;
  forceLoading$: Observable<boolean>;
  values$: Observable<any>;
  siteData$: Observable<any>;
  siteDataSub: Subscription;
  sortingArray = []
  columnSettings: ColumnSetting[]

  constructor(private productService : ProductService, private systemService: SystemService, private reportService: CompanyReportGeneratorService, private route: ActivatedRoute, private siteService: CompanysitesService) {


    let params = this.route.snapshot.queryParams;


    let focusBy = params['focusBy'];


    if (focusBy == 'BYPRODUCT') {
      this.columnSettings = [
        {
          columnId: 'productName',
          name: 'Product Name',
          maxLengthOnMobile: 10,
        },
        {
          columnId: 'systemName',
          name: 'System Name',
          hideOnMobile: true
        },
        // {
        //   columnId: 'productNumber',
        //   name: 'Product #',

        // },

        {
          columnId: 'qty',
          name: 'Quantity',
        },
        {
          columnId: 'price',
          name: 'Price',
        }
      ]
      this.sortingArray = ['Product Name', 'Product #', 'System Name', 'Quantity', 'Str. Qty.', 'Date', 'OrderId']

    } else if (focusBy == 'ALL') {
      this.columnSettings = [

        {
          columnId: 'productName',
          name: 'Product Name',
          class: "mobile"
        },
        {
          columnId: 'systemName',
          name: 'System Name',
          hideOnMobile: true,
          class: "mobile"

        },
        {
          columnId: 'date',
          name: 'Date',
          hideOnMobile: true,
          class: "mobile"

        },
        {
          columnId: 'orderID',
          name: 'OrderId',
          class: "mobile"

        },
        {
          columnId: 'payType',
          name: 'Type',
          class: "mobile"

        }, {
          columnId: 'discount',
          name: 'Subsidy',
          class: "mobile"

        },
        {
          columnId: 'price',
          name: 'Price',
          class: "mobile"

        },
        {
          columnId: 'pant',
          name: 'Pant',
          class: "mobile"
        }, {
          columnId: 'mva',
          name: 'MVA',
          class: "mobile"

        },
        {
          columnId: 'mvaPrice',
          name: 'MVA Price',
          class: "mobile"

        },


        {
          columnId: 'subsidized',
          name: 'Subsidized',
          class: "mobile"

        },
        {
          columnId: 'salepriceWithoutMVA',
          name: 'salepriceWithoutMVA',
          class: "mobile"

        },
        {
          columnId: 'groupId',
          name: 'Group',
          class: "mobile"

        },
        {
          columnId: 'userName',
          name: 'Name',
          class: "mobile"

        },
        {
          columnId: 'status',
          name: 'Status',
          class: "mobile"

        },
        {
          columnId: 'category',
          name: 'Category',
          class: "mobile"

        }

      ]
      this.sortingArray = ['Product Name', 'System Name', 'Quantity', 'Date', 'OrderId', 'Type', 'Subsidy', "Name", 'Group', "Subsidized", 'Status', 'Price', "MVA", "MVA Price", 'salepriceWithoutMVA', "Pant", "Category"]

    }

    if (focusBy == 'BYPRODUCT') {
      this.values$ = this.reportService.getDataByProduct(params);
    } else if (focusBy == 'ALL') {
      this.values$ = this.reportService.getAll(params).pipe(map(data => {
        return data.map(item => {
          return {
          ...item,
          category: item.categories ? item.categories.join(',') : "",
        }
        }) as any[];
      }));
    }
    //  this.values$.subscribe(data => {
    //   data.forEach(async element => {
    //     console.log(element['dbid']);
    //     if(element.categories.includes('drikkevarer')) {
    //       let product = await this.productService.getProductById(element.productId);

    //       this.systemService.updateTranaction(element['dbid'],{pant:product['pant']})
    //     }
    //   });
    
    // })
  }
  ngOnDestroy(): void {
    if (this.siteDataSub) this.siteDataSub.unsubscribe();
  }

}
